import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IPointOfView } from '@obvious.tech/constellation'

export const PointOfView = defineEntity('PointOfView', {
  endpoint: 'cartography/api/PointOfView',
  schema: SNoop<IPointOfView>(),
})
